<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1> {{ user.fullname }} </h1>
        <h3>{{ user.email }}</h3>
        <h1> 
          {{ $tc('models.fiscalDatum', 2) }} 
          <v-btn color="primary" outline @click="goTo('users', { userFiltersStore: true })"> {{ $t('back') }} </v-btn>
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-card>
          <v-card-text v-if="fiscalDatum.id">
            <div>

              <p>
              {{ $t('attrs.business_name') }}
              <strong>{{ fiscalDatum.business_name }}</strong>
              <br />
              {{ $t('attrs.rfc') }}
              <strong>{{ fiscalDatum.rfc }}</strong>
              <br />
              {{ $t('attrs.fiscal_regime') }}
              <strong>{{ fiscalDatum.fiscal_regime }}</strong>
              <br />
              {{ $t('attrs.payment_form') }}
              <strong>{{ fiscalDatum.payment_form }}</strong>
              <br />
              {{ $t('attrs.cfdi_use') }}
              <strong>{{ fiscalDatum.cfdi_use }} - {{ cfdiUse[fiscalDatum.cfdi_use] }}</strong>
              <br />
              {{ $t('attrs.email') }}
              <strong>{{ fiscalDatum.email }}</strong>
              <br />
              {{ $t('attrs.phone') }}
              <strong>{{ fiscalDatum.phone }}</strong>
              </p>

              <p>
              {{ fiscalDatum.street }}
              {{ fiscalDatum.number }}
              {{ fiscalDatum.interior_number }}

              <br />

              {{ fiscalDatum.neighborhood }},
              {{ fiscalDatum.city }},
              {{ fiscalDatum.state }}

              <br />

              {{ fiscalDatum.country.name }}
              {{ fiscalDatum.postal_code }}
              </p>

            </div>
          </v-card-text>

          <v-card-text v-if="!fiscalDatum.id" class="text-xs-center">
            {{ $t('noDataAvailable') }}
          </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="goTo('users', { userFiltersStore: true })">{{ $t('back') }}</v-btn>
            </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import User from '@/client/user'
import FiscalDatum from '@/client/fiscal-datum'
import CfdiUse from '@/cfdi-use.json'

export default {
  name: 'UserFiscalDataView',

  props: {},

  data () {
    return {
      user: {},
      fiscalDatum: {},
      cfdiUse: CfdiUse.reduce((p, c) => {
        p[c['id']] = c['name']
        return p
      }, {}),
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
  },

  watch: {
  },

  async mounted () {
    this.user = await User.findOne(this.$route.params.userId, {
      include: { fiscal_datum: 'country' }
    })

    const fiscalData = await FiscalDatum.all({ where: { user_id: this.$route.params.userId } })
    this.fiscalDatum = fiscalData[0] || {}
  }
}
</script>
